import styled from 'styled-components';
import { contiOrange, white } from '../../../style/colors';

export const Container = styled.div`
  background: white;
  padding: 0;
  width: 100%;
`;

export const StatusTogglesWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const StatusToggle = styled.button`
  background: ${(props) => (props.active ? contiOrange : white)};
  border: 2px solid ${(props) => (props.active ? contiOrange : '#e8e8e8')};
  color: ${(props) => (props.active ? white : '#666')};
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${(props) => 
    props.active 
      ? '0 2px 8px rgba(255, 165, 0, 0.25)' 
      : '0 1px 2px rgba(0, 0, 0, 0.04)'};
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover:not(:disabled) {
    border-color: ${contiOrange};
    color: ${(props) => (props.active ? white : contiOrange)};
    background: ${(props) => (props.active ? contiOrange : '#fff5f0')};
    transform: translateY(-1px);
    box-shadow: ${(props) => 
      props.active 
        ? '0 4px 12px rgba(255, 165, 0, 0.35)' 
        : '0 2px 4px rgba(255, 165, 0, 0.15)'};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

